import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { useDispatch } from "react-redux";
import { Weekly } from "./Weekly";
import { Monthly } from "./Monthly";
import { showToast } from "services/utils/Status";
import { themes } from "services/constants";
import { useSelector } from "react-redux";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { startOfMonth, endOfMonth } from "date-fns";
import moment from "moment";
import sessionHandling from "services/utils/notificationUtils";
import { CustomToggleButton } from "components/CustomComponents/CustomToggleButton";
import { setGlobalSearchValue } from "services/Redux/userToken";

export const MyShift = () => {
  const [dataVisualMethod, setDataVisualMethod] = useState("Weekly");
  const { domain, token, userDetails, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );
  const [showWorkUnitData, setShowWorkUnitData] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [weeklyselectedDate, setWeeklySelectedDate] = useState(new Date());
  const [formattedDate, setFormattedDate] = useState(new Date(), "yyyy-MM");
  const [loading, setIsLoading] = useState(false);
  const [fetchWeekly, setFetchWeekly] = useState(false);
  const [monthlyShiftList, setMonthlyShiftList] = useState([]);
  const [weeklyShiftList, setWeeklyShiftList] = useState([]);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [listOfDate, setListOfDate] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const minDate = new Date(2020, 0, 1);
  const [alignment, setAlignment] = useState("Weekly");
  const dispatch = useDispatch();

  const buttons = [
    {
      value: "Weekly",
      label: "Weekly",
      onClick: () => {
        setDataVisualMethod("Weekly");
        dispatch(setGlobalSearchValue(""));
        setSelectedWeek(getCurrentWeek);
      },
    },
    {
      value: "Monthly",
      label: "Monthly",
      onClick: () => {
        setDataVisualMethod("Monthly");
        dispatch(setGlobalSearchValue(""));
      },
    },
  ];

  const getCurrentWeek = () => moment().format("GGGG-[W]WW");

  const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek);

  const handleWeeklyDateOnChange = (event) => {
    setSelectedWeek(event.target.value);
  };

  const handleMonthlyDateOnChange = (date) => {
    if (
      date instanceof Date &&
      !isNaN(date) &&
      date.getFullYear().toString().length === 4 &&
      date >= minDate
    ) {
      setWeeklySelectedDate(date);
    } else if (date.getFullYear().toString().length === 4 && date < minDate) {
      showToast("error", "Year must be 01/01/2020 or later");
    }
  };

  const getWeekDays = (startDate) => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(startDate);
      day.setDate(startDate.getDate() + i);
      days.push(day);
    }
    return days;
  };

  const getMonthDays = (startDate) => {
    const days = [];
    const year = startDate.getFullYear();
    const month = startDate.getMonth();

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    let currentDate = firstDayOfMonth;

    while (currentDate <= lastDayOfMonth) {
      days.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return days;
  };

  useEffect(() => {
    if (selectedWeek && dataVisualMethod) {
      if (dataVisualMethod === "Weekly") {
        const startDate = moment(selectedWeek).startOf("isoWeek").toDate();
        const endDate = moment(selectedWeek).endOf("isoWeek").toDate();
        const dates = getWeekDays(startDate);
        const formatDates = dates?.map((value) =>
          moment(value).format("YYYY-MM-DD")
        );
        setListOfDate([]);
        setStartDate("");
        setEndDate("");
        setListOfDate(formatDates);
        setStartDate(moment(startDate).format("YYYY-MM-DD"));
        setEndDate(moment(endDate).format("YYYY-MM-DD"));
        if (startDate !== "" && endDate !== "") {
          setFetchWeekly(true);
        }
      } else {
        const start = startOfMonth(weeklyselectedDate);
        const end = endOfMonth(weeklyselectedDate);
        const dates = getMonthDays(start);
        const formatDates = dates?.map((value) =>
          moment(value).format("YYYY-MM-DD")
        );
        setListOfDate([]);
        setStartDate("");
        setEndDate("");
        setListOfDate(formatDates);
        setStartDate(moment(start).format("YYYY-MM-DD"));
        setEndDate(moment(end).format("YYYY-MM-DD"));
        if (start !== "" && end !== "") {
          setFetchWeekly(true);
        }
      }
    }
  }, [dataVisualMethod, selectedWeek, weeklyselectedDate, startDate, endDate]);

  useEffect(() => {
    const formatDate = () => {
      if (weeklyselectedDate) {
        const formattedDate =
          weeklyselectedDate?.getFullYear() +
          "-" +
          ("0" + (weeklyselectedDate?.getMonth() + 1)).slice(-2);
        setFormattedDate(formattedDate);
      }
    };
    formatDate();
    if (formattedDate && dataVisualMethod === "Monthly") {
      setFetchWeekly(true);
    }
  }, [dataVisualMethod, formattedDate, weeklyselectedDate]);

  useEffect(() => {
    const fetchWeeklyShiftList = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${domain}daily_user_shift_assignments/?selected_user_id=${userDetails?.id}&from_date=${startDate}&to_date=${endDate}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setMasterDataForSearch([]);
          dataVisualMethod === "Monthly"
            ? setMonthlyShiftList([])
            : setWeeklyShiftList([]);

          if (dataVisualMethod === "Monthly") {
            if (res?.data) {
              const adminLeaveEvents = res?.data[0]?.shifts.map(
                (request, index) => {
                  const from_Date = new Date(
                    request.date.split("-").reverse().join("-")
                  );
                  return {
                    id: `myshift_${index}`,
                    title: request?.shift_name
                      ? request?.shift_name
                      : "Not Joined",
                    start: from_Date,
                    end: from_Date,
                    shift_start_time: request.shift_start_time,
                    shift_end_time: request.shift_end_time,
                    is_custom: request.is_custom,
                    is_weekoff: request.is_weekoff,
                  };
                }
              );
              setMonthlyShiftList([...adminLeaveEvents]);
              setMasterDataForSearch([...adminLeaveEvents]);
              setMonthlyData(res?.data[0]?.shifts);
            }
          } else {
            setWeeklyShiftList(res?.data);
            setShowWorkUnitData(res?.data ? res?.data[0]?.work_unit : false);
            setMasterDataForSearch(res?.data);
          }

          setIsLoading(false);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
        setIsLoading(false);
      }
    };
    if (
      fetchWeekly &&
      startDate !== "" &&
      endDate !== "" &&
      userDetails?.id !== ""
    ) {
      fetchWeeklyShiftList();
      setFetchWeekly(false);
    }
  }, [
    domain,
    endDate,
    fetchWeekly,
    startDate,
    token,
    userDetails?.id,
    dataVisualMethod,
  ]);

  useEffect(() => {
    const FilterWeeklyData = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toLowerCase()) > -1
            : null
        )
      );
    };
    if (globalSearchValue && dataVisualMethod === "Weekly") {
      setWeeklyShiftList(FilterWeeklyData());
    }
  }, [globalSearchValue, masterDataForSearch, dataVisualMethod]);

  return (
    <React.Fragment>
      <Mui.Grid container spacing={1} sx={{ mt: 3 }}>
        <Mui.Grid item xs={12} sm={6} md={4} lg={2}>
          <CustomToggleButton
            alignment={alignment}
            handleChange={(_, newVal) => newVal && setAlignment(newVal)}
            buttons={buttons}
            themes={themes}
          />
        </Mui.Grid>
        <Mui.Grid item md={4} lg={7.8}></Mui.Grid>
        <Mui.Grid item xs={12} sm={5} md={4} lg={2.1}>
          <Mui.Stack
            style={{
              display: "flex",
              flexDirection: "row",
              paddingTop: 1,
              alignSelf: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            {dataVisualMethod === "Monthly" ? (
              <>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    size="small"
                    label="Select Date"
                    views={["year", "month"]}
                    value={weeklyselectedDate}
                    minDate={minDate}
                    onChange={handleMonthlyDateOnChange}
                    slotProps={{ textField: { size: "small" } }}
                    style={{
                      width: 250,
                    }}
                    renderInput={(params) => (
                      <Mui.TextField {...params} size="small" />
                    )}
                  />
                </LocalizationProvider>
              </>
            ) : (
              <>
                <Mui.TextField
                  label="Select Week"
                  size="small"
                  type="week"
                  value={selectedWeek}
                  onChange={handleWeeklyDateOnChange}
                  style={{
                    width: 250,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </>
            )}
          </Mui.Stack>
        </Mui.Grid>
      </Mui.Grid>

      <Mui.Grid>
        {dataVisualMethod === "Weekly" ? (
          <Weekly
            loading={loading}
            weeklyShiftList={weeklyShiftList}
            listOfDate={listOfDate}
            showWorkUnitData={showWorkUnitData}
            masterDataForSearch={masterDataForSearch}
          />
        ) : (
          <Monthly
            loading={loading}
            monthlyShiftList={monthlyShiftList}
            listOfDate={listOfDate}
            startDate={startDate}
            endDate={endDate}
            monthlyData={monthlyData}
          />
        )}
      </Mui.Grid>
    </React.Fragment>
  );
};
